import * as React from 'react'
import BaseIcon from 'react-icon-base'

const AchievementIcon = props => (
  <BaseIcon width="40" height="40" viewBox="0 0 40 40" {...props}>
    <g fill="none" fillRule="evenodd" opacity=".9">
      <rect width="40" height="40" fill="#2ED8A7" rx="20" />
      <path
        fill="#FFF"
        d="M16.632 23.706l10.461-10.462a.833.833 0 0 1 1.179 0l1.178 1.179a.833.833 0 0 1 0 1.178L17.315 27.736a.833.833 0 0 1-1.178 0l-5.893-5.892a.833.833 0 0 1 0-1.179l1.084-1.084a.833.833 0 0 1 1.179 0l4.125 4.125z"
      />
    </g>
  </BaseIcon>
)

export default AchievementIcon
